import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { IHomePageBanner } from './model';

import './HomePageBanner.scss';
import DangerouslySetInnerHtml from '../common/DangerouslySetInnerHtml';
import UniversalImage from '../common/UniversalImage';

const HomePageBanner: FC<IHomePageBanner> = ({
  background,
  mainImage,
  productImage,
  productLabel,
  title,
  disclaimer,
}) => {
  return (
    <section className="home-banner">
      <div className="home-banner__background">
        <UniversalImage
          imageStyle={{ width: '100%', height: '100%' }}
          imageAlt="Background image"
          img={background.fallbackUrl}
          backgroundColor="transparent"
          objectFitData={{ objectFit: 'cover' }}
        />
      </div>
      <div className="home-banner__content">
        <div className="home-banner__text-wrapper">
          <DangerouslySetInnerHtml className="main-text" html={title} />

          <div className="home-banner__product-label-wrapper">
            <div className="home-banner__product-label">
              <div className="home-banner__product-image-wrapper">
                <UniversalImage
                  imageStyle={{ width: '100%' }}
                  imageAlt="Product image"
                  img={productImage.fallbackUrl}
                  backgroundColor="transparent"
                />
              </div>
              <DangerouslySetInnerHtml
                html={productLabel}
                className="home-banner__product-label-text"
              />
            </div>
            <div className="home-banner__main-image-tablet">
              <UniversalImage
                imageStyle={{ height: '100%', width: '100%' }}
                imageAlt="Main image"
                img={mainImage.fallbackUrl}
                backgroundColor="transparent"
              />
            </div>
          </div>
        </div>
        <div className="home-banner__main-image">
          <UniversalImage
            imageStyle={{ height: '100%' }}
            imageAlt="Main image"
            img={mainImage.fallbackUrl}
            backgroundColor="transparent"
          />
        </div>
        <div className="home-banner__product-label-large">
          <div className="home-banner__product-image-wrapper">
            <UniversalImage
              imageStyle={{ width: '100%' }}
              imageAlt="Product image"
              img={productImage.fallbackUrl}
              backgroundColor="transparent"
            />
          </div>
          <DangerouslySetInnerHtml
            html={productLabel}
            className="home-banner__product-label-text"
          />
        </div>
      </div>
      <DangerouslySetInnerHtml className="disclaimer" html={disclaimer} />
    </section>
  );
};

export const query = graphql`
  fragment FragmentHomePageBanner on IHomePageBanner {
    title
    productLabel
    disclaimer
    mainImage {
      fallbackUrl
      gatsbyImage {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
    productImage {
      fallbackUrl
      gatsbyImage {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
    background {
      fallbackUrl
      gatsbyImage {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
`;

export default HomePageBanner;
